import { render, staticRenderFns } from "./DynamicForms.vue?vue&type=template&id=57fcd1d0&"
import script from "./DynamicForms.vue?vue&type=script&lang=js&"
export * from "./DynamicForms.vue?vue&type=script&lang=js&"
import style0 from "./DynamicForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports